// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__31r12","title":"Header_title__3d5Zt","side":"Header_side__1NJwN"};